var React = require('react');

function BatterySlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M165.31 96H560a48 48 0 0 1 48 48v16h8a24 24 0 0 1 24 24v144a24 24 0 0 1-24 24h-8v16a48 48 0 0 1-32.14 45.31L496.54 352H544v-64h32v-64h-32v-64H248.12zM64 352V179.49l-62.13-48A47.37 47.37 0 0 0 0 144v224a48 48 0 0 0 48 48h322l-82.81-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M633.83 458.11L45.47 3.38A16 16 0 0 0 23 6.17L3.37 31.46a16 16 0 0 0 2.81 22.45l588.35 454.73a16 16 0 0 0 22.47-2.79l19.64-25.27a16 16 0 0 0-2.81-22.47z","className":"fa-primary","key":2})]);
}

BatterySlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BatterySlash;

BatterySlash.default = BatterySlash;
